import { Backdrop, CircularProgress } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { PrivateLayoutContext } from "../../components/layout-mui/PrivateLayout";
import { Sections } from "../../components/layout-mui/Sections";

export const Abm = ({
  title = "",
  tabs,
  keyState,
  loading = false
}) => {
  const {setHeaderContent} = useContext(PrivateLayoutContext);
  const [activeKey, setActiveKey] = keyState;

  useEffect(()=>{
    setHeaderContent(title);
    handleSelectTab(activeKey);
  }, [])
 
  const handleSelectTab = (key) => {
    //console.log(key)
    //tabs.find(tab => tab.key===key)?.onSelect();
    setActiveKey(key);
  }

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Sections tabs={tabs} activeKey={activeKey} onSelectTab={handleSelectTab}/>
    </>
  );
}
